export default "__VITE_ASSET__1312fce0__"